import React from 'react';
import PageLayout from 'components/PageLayout';

function Home() {
  return (
    <PageLayout title="Home">
      <p className="text-zinc-400">Landing page coming at some point.</p>
    </PageLayout>
  );
}

export default Home;
